import React, { createContext, useContext, useEffect, useState } from 'react';

const CookieConsentContext = createContext(null);

export const useCookieConsent = () => {
    return useContext(CookieConsentContext);
};

export const CookieConsentProvider = ({ children }) => {
    const [preferences, setPreferences] = useState(null);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const storedPreferences = localStorage.getItem('cookie_preferences');
        if (storedPreferences) {
            try {
                const parsed = JSON.parse(storedPreferences);
                setPreferences(parsed);
                applyPreferences(parsed);
            } catch (e) {
                console.error("Error parsing cookie preferences", e);
            }
        } else {
            // Show banner if no preferences found
            setShowBanner(true);
        }
    }, []);

    const applyPreferences = (prefs) => {
        if (prefs.analytics) {
            // Check if GA script already exists
            if (!document.getElementById('ga-script')) {
                const script1 = document.createElement('script');
                script1.id = 'ga-script';
                script1.async = true;
                script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-1JL6K2W0T3';
                document.head.appendChild(script1);

                const script2 = document.createElement('script');
                script2.id = 'ga-script-init';
                script2.innerHTML = `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-1JL6K2W0T3');
                `;
                document.head.appendChild(script2);
            }
        }
    };

    const updatePreferences = (newPreferences) => {
        const prefsWithEssential = { ...newPreferences, essential: true };
        setPreferences(prefsWithEssential);
        localStorage.setItem('cookie_preferences', JSON.stringify(prefsWithEssential));
        applyPreferences(prefsWithEssential);
        setShowBanner(false);
    };

    return (
        <CookieConsentContext.Provider value={{ preferences, updatePreferences, showBanner, setShowBanner }}>
            {children}
        </CookieConsentContext.Provider>
    );
};
